import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import './AchievementPopup.css';

const AchievementPopup = () => {
  const { pendingAchievements, clearPendingAchievement } = useGame();
  const [visible, setVisible] = useState(false);
  const [currentAchievement, setCurrentAchievement] = useState(null);

  useEffect(() => {
    if (pendingAchievements.length > 0 && !visible) {
      setCurrentAchievement(pendingAchievements[0]);
      setVisible(true);

      // Auto-hide after 4 seconds
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => {
          clearPendingAchievement();
          setCurrentAchievement(null);
        }, 300); // Wait for fade out animation
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [pendingAchievements, visible, clearPendingAchievement]);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(() => {
      clearPendingAchievement();
      setCurrentAchievement(null);
    }, 300);
  };

  if (!currentAchievement) return null;

  return (
    <div className={`achievement-popup ${visible ? 'visible' : ''}`} onClick={handleDismiss}>
      <div className="achievement-popup-content">
        <div className="achievement-popup-header">
          <span className="achievement-popup-label">Achievement Unlocked!</span>
        </div>
        <div className="achievement-popup-body">
          <div className="achievement-popup-icon">{currentAchievement.icon}</div>
          <div className="achievement-popup-details">
            <h3 className="achievement-popup-name">{currentAchievement.name}</h3>
            <p className="achievement-popup-description">{currentAchievement.description}</p>
          </div>
        </div>
        <div className="achievement-popup-footer">
          <span className="achievement-popup-category">{currentAchievement.category}</span>
          <span className="achievement-popup-dismiss">Click to dismiss</span>
        </div>
      </div>
    </div>
  );
};

export default AchievementPopup;
